import React, { PureComponent } from 'react';

import CustomAutocomplete from 'Common/CustomAutocomplete';
import { COUNTRIES } from 'Constants';

const countries = Object.keys(COUNTRIES).map(key => {
    return { value: key, label: COUNTRIES[key] };
});

export default class CountryAutocomplete extends PureComponent {

    /**
     * @returns {*}
     */
    render() {
        const props = this.props;

        return (
            <CustomAutocomplete
                {...props}
                filterable
                options={countries}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Autocomplete/CountryAutocomplete.jsx